import { BreadcrumbItem } from '@components/atoms/ui-kit/breadcrumbs.tsx';

export const buildCustomModelBreadcrumbTrail = (
  modelName: string
): BreadcrumbItem[] => [
  {
    id: 'model',
    name: modelName
  }
];
